import "../css/work.css";
import show1 from "../images/small small show10.jpg";
import show2 from "../images/small show2.jpg";
import show3 from "../images/show15.jpg";
import show4 from "../images/small show9.jpg";
import show5 from "../images/show1.jpg";
import show6 from "../images/small show13.jpg";
import show7 from "../images/small 062A8721.jpg";
import show8 from "../images/small show12.jpg";
import show9 from "../images/show11.jpg";
import show10 from "../images/small show16.jpg"
import show11 from "../images/show.jpg"
import show12 from "../images/small show7.jpg"
import show13 from "../images/small show17.jpg"
import show14 from "../images/small show3.jpg"
import show15 from "../images/small show14.jpg"
import show16 from "../images/small show6.jpg"
import show17 from "../images/small show5.jpg"
import show18 from "../images/show20.jpg"

function Work() {
  return (
    <div className="work-container">
      <img className="work-img" src={show1} alt="show 1 artwork" />
      <p className="work-img-text">
        <i>Check Shadow</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        7 5⁄8 x 8 3⁄4 in
        <br />
      </p>
      <img className="work-img" src={show2} alt="show 2 artwork" />
      <p className="work-img-text">
        <i>Calendar</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        7 5⁄8 x 8 3⁄4 in
        <br />
      </p>
      <img className="work-img" src={show3} alt="show 3 artwork" />
      <p className="work-img-text">
        <i>Rebis</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        5 x 7 3⁄4 in
        <br />
        5 7⁄8 in x 7 3⁄4 in
        <br />
      </p>
      <img className="work-img" src={show4} alt="show 4 artwork" />
      <p className="work-img-text">
        <i>Two Bellies</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        7 3⁄4 x 4 3⁄4 in
        <br />
      </p>
      <img className="work-img" src={show5} alt="show 5 artwork" />
      <p className="work-img-text">
        <i>Slip</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        8 3⁄4 x 7 3⁄4 in
        <br />
      </p>
      <img className="work-img" src={show6} alt="show 6 artwork" />
      <p className="work-img-text">
        <i>Pop ash pond</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        5 x 7 3⁄4 in
        <br />
      </p>
      <img className="work-img" src={show7} alt="show 7 artwork" />
      <p className="work-img-text">
        <i>Dance</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        4 3⁄4 in x 7 3⁄4 in
        <br />
      </p>
      <img className="work-img" src={show8} alt="show 8 artwork" />
      <p className="work-img-text">
        <i>Conjunction</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        4 1⁄2 x 7 3⁄4 in
        <br />
      </p>
      <img className="work-img" src={show9} alt="show 9 artwork" />
      <p className="work-img-text">
        <i>Nebula</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        4 3⁄4 x 7 3⁄4 in
        <br />
      </p>
      <img className="work-img" src={show10} alt="show 10 artwork" />
      <p className="work-img-text">
        <i>Fingers petals rays</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        7 3⁄4 x 5 1⁄4 in
        <br />
      </p>
      <img className="work-img" src={show11} alt="show 11 artwork" />
      <p className="work-img-text">
        <i>Untitled</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        5 1⁄4 x 7 3⁄4 in
        <br />
      </p>
      <img className="work-img" src={show12} alt="show 12 artwork" />
      <p className="work-img-text">
        <i>Shedding</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        6 3⁄4 in x 9 3⁄8 in
        <br />
      </p>
      <img className="work-img" src={show13} alt="show 13 artwork" />
      <p className="work-img-text">
        <i>Untitled</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        4 3⁄4 x 7 3⁄4 in
        <br />
      </p>
      <img className="work-img" src={show14} alt="show 14 artwork" />
      <p className="work-img-text">
        <i>Balm</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        4 3⁄8 x 8 in
        <br />
      </p>
      <img className="work-img" src={show15} alt="show 15 artwork" />
      <p className="work-img-text">
        <i>Leak</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        4 3⁄4 x 7 3⁄4 in
        <br />
      </p>
      <img className="work-img" src={show16} alt="show 16 artwork" />
      <p className="work-img-text">
        <i>Untitled</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        4 1⁄2 x 7 3⁄4 in
        <br />
      </p>
      <img className="work-img" src={show17} alt="show 17 artwork" />
      <p className="work-img-text">
        <i>Thick Tendrils</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        4 3⁄4 x 7 3⁄4 in
        <br />
      </p>
      <img className="work-img" src={show18} alt="show 18 artwork" />
      <p className="work-img-text">
        <i>Shell</i>
        <br />
        Unique silver gelatin chemigram mounted on 16-Gauge steel
        <br />
        4 3⁄4 x 7 3⁄4 in
        <br />
      </p>
    </div>
  );
}

export default Work;
